import BaseService from "./BaseService";

class DailyListService extends BaseService {

    constructor() {
        super("/daily-lists");
    }

}

const dailyListService = new DailyListService();

export default dailyListService;
